import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Fragment} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {Chip} from '@material-ui/core'
import {BuilderCardLoader, CatalogItemPreviewMenuItem, ContextMenuItem, FILTER_UNASSIGNED_ID, MyGroupSwatch, OpenInC8MenuItem, useAssortmentCardStore, useAssortmentHeroCardStore, useHeroCardSecondLevelStore, useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogFieldConfig, icons, StoresInstance} from '@stores'
import * as css from './AssortmentCardContextMenuItems.css'

export const AssortmentCardContextMenuItems = observer(function AssortmentCardContextMenuItems() {
  const {} = useAssortmentCardStore()

  return (<Fragment>
    <AssortmentCardFilterMenuItems/>
  </Fragment>)
})

export const AssortmentCardFilterMenuItems = observer(function AssortmentCardFilterMenuItems() {
  const {contextMenu: {store}, es, assortment, title, filterGroup, titleField, catalog, filterGroupKey, data} = useAssortmentCardStore(),
    heroCard = useAssortmentHeroCardStore(),
    secondLevelCard = useHeroCardSecondLevelStore()

  return !filterGroup ? null : (
    <ContextMenuItem icon={icons.filter} text='Filter'>
      {assortment.grouping.map(f => {
        const field = catalog.findFieldInTree(f)

        return field ? <ContextMenuItem icon={'header'} key={field.field} text={catalog.labelForField(field)}>
          <FilterMenuItems filterKey={field.field} value={es.readField(data, catalog.filter.filterFieldFor(field))?.val}/>
        </ContextMenuItem>: null
      })}
      <ContextMenuItem icon={'header'} text={catalog.labelForField(titleField)}>
        <FilterMenuItems filterKey={filterGroupKey} value={data}/>
       {/*<ContextMenuItem icon={isFilterSelected ? 'tick' : 'blank'}*/}
        {/*                 text={`Filter '${title}'`}*/}
        {/*                 onClick={toggleFilterSelected}/>*/}
        {/*<ContextMenuItem icon={isFilterExcluded ? 'tick' : 'blank'}*/}
        {/*                 text={`Exclude '${title}'`}*/}
        {/*                 onClick={toggleFilterExcluded}/>*/}
      </ContextMenuItem>

      {(assortment?.dataMap?.attributes ?? []).map(({field, label}, i) => <ContextMenuItem key={i} icon={'blank'} text={label ?? catalog.labelForFieldName_currentCatalog(field)}>
        <FilterMenuItems key={i} filterKey={field} value={es.readField(data, field)?.val}/>
      </ContextMenuItem>)}

      {heroCard?.catalogFieldSkeleton && <ContextMenuItem icon={icons.card} text={catalog.labelForField(heroCard.catalogFieldSkeleton)}>
	      <HeroCardFilterMenuItems />
      </ContextMenuItem>}
      {secondLevelCard && <SecondLevelHeroCardFilterMenuItems/>}

    </ContextMenuItem>
  )
})

export const HeroCardFilterMenuItems = observer(function HeroCardFilterMenuItems() {
  const store = useAssortmentHeroCardStore()

  if (!store?.filterGroup) return null

  return <FilterMenuItems filterKey={store.filterGroupKey} value={store.filterValueRaw} />

  // const {isFilterExcluded, isFilterSelected, toggleFilterExcluded, toggleFilterSelected, filterValueAsText, catalog, catalogFieldSkeleton} = store
  // return (<Fragment>
  //       <ContextMenuItem icon={isFilterSelected ? 'tick' : 'blank'}
  //                        text={`Filter for '${filterValueAsText}'`}
  //                        onClick={toggleFilterSelected}/>
  //       <ContextMenuItem icon={isFilterExcluded ? 'tick' : 'blank'}
  //                        text={`Exclude '${filterValueAsText}'`}
  //                        onClick={toggleFilterExcluded}/>
  // </Fragment>)
})

export const FilterMenuItems = observer<{filterKey: string, value?: any}>(function HeroCardFilterMenuItems({filterKey, value}) {
  const {filter, catalog} = useStores()

  let filterGroup = filter.groupFor(filterKey)

  // console.log(`FilterMenuItems`, {filterKey, filterGroup, value})
  if (_.isEmpty(filterGroup)) {
    console.warn(`Cannot find filter group for ${filterKey}`)
    return null
  }

  const catalogField = catalog._fieldByName[filterKey]
  if (!catalogField) return null

  let filterFieldPath = filter.filterFieldFor(catalogField)
  let v = value
  if (_.isPlainObject(value)) {
    if (value.__path) {
      if (!filterFieldPath.startsWith(value.__path)) {
        return
      }

      filterFieldPath = filterFieldPath.substring(value.__path.length + 1)
    }
   v = filterFieldPath ? _.get(value, filterFieldPath) : value
  }

  const filterValue = v === null ? FILTER_UNASSIGNED_ID : _.isArray(v) ? _.first(v) : v,
    {selected, excluded} = filterGroup,
    isFilterSelected = selected.has(filterValue),
    isFilterExcluded = excluded.has(filterValue),
    filterValueAsText = filter.labelFor({group: filterKey, value: filterValue}),
    label = catalog.labelForField(catalogField)

  //const {isFilterExcluded, isFilterSelected, toggleFilterExcluded, toggleFilterSelected, filterValueAsText, catalog, catalogField} = store
  return (<Fragment>
    <ContextMenuItem icon={isFilterSelected ? 'tick' : 'blank'}
                     text={`Filter for '${filterValueAsText}'`}
                     title={label}
                     onClick={() => filter.toggleFilter({key: filterGroup.key, value: filterValue})}/>
    <ContextMenuItem icon={isFilterExcluded ? 'tick' : 'blank'}
                     title={label}
                     text={`Exclude '${filterValueAsText}'`}
                     onClick={() => filter.toggleFilter({key: filterGroup.key, value: filterValue, exclude: true})}/>
  </Fragment>)
})

export const SecondLevelHeroCardFilterMenuItems = observer(function SecondLevelHeroCardFilterMenuItems() {
    const {foreignKeyField, item} = useHeroCardSecondLevelStore()

    return (!foreignKeyField ? null : <Fragment>
      <ContextMenuItem icon='flow-branch' text='2nd-level Card Filter'>
        <FilterMenuItems filterKey={foreignKeyField.field} value={item} />
      </ContextMenuItem>
    </Fragment>)
})


export const CatalogFieldValueContextMenuItem = observer<{field: ICatalogFieldConfig, value: any}>(function CatalogFieldValueContextMenuItem({field, value}) {
    const {catalog, filter, catalog: {labelForField, idFor, associatedWorkspaceFor}} = useStores(),
      ws = field?.esIndex ? associatedWorkspaceFor(field) : catalog.workspace,
      filterGroup = field ? filter.groupFor(field.field) : null,
      id = ws ? (idFor(value, false) ?? idFor(value?.__parent, false))
              : null

  console.debug(`CatalogFieldValueContextMenuItem`, {ws, field, value, id})
  //{ws && <ContextMenuItem text={`Preview...`} icon={icons.previewCard} noSubmenuPadding>
    return (
      <Fragment>
        {!value ? null : <CatalogItemPreviewMenuItem showWorkspaceTitle data={value} index={ws?.catalog?.index} workspace={ws?.config} noSubmenuPadding={ws != null}>
          {ws ? <Fragment>
            {/*<div className={css.previewCardToolbar} />*/}
	          <BuilderCardLoader levelOfDetail={1} isPopover useDefaultFieldsIfNoneSet showImage
	                             id={id}
	                             workspace={ws.config}/>

      </Fragment>
      : <Fragment>
          <MenuDivider/>
          {(field?.esIndex || !field) && <OpenInC8MenuItem id={id} />}
          {filterGroup && <FilterMenuItems filterKey={field.field} value={value}  /> }
           </Fragment>}
        </CatalogItemPreviewMenuItem>}
    </Fragment>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/AssortmentCardContextMenuItems.tsx